export default __webpack_public_path__ + "static/media/sp-icon.f5ee8a26.webp";